@use "variables" as *;

.albumsTitle {
  display: flex;
  align-items: center;
  padding: 0 0 0 $spacing-m;
  z-index: 1000;
}

.albumsText {
  margin: $spacing-m 0;
  font-size: $fontSize-s;
  font-weight: bold;
}
